import { useMutation } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'
import { pandaAccessToken } from './useGetDocuments'

const draftDocument = async updateData => {
  const { PK, SK, contractId } = updateData ?? {}
  const url = `${baseUrl}/aws/pandadoc/${contractId}/draft`
  if (!pandaAccessToken) {
    console.error('No authentication token available')
    return
  }
  try {
    const response = await axios.post(
      url,
      { PK, SK },
      {
        headers: { Authorization: ` ${pandaAccessToken}` },
      }
    )
    console.log('Response draft document: ', response)
    return response.data
  } catch (error) {
    console.error('Error setting doc to draft:', error)
    throw error // Re-throw the error for useMutation's onError to catch
  }
}

export const useDraftDocument = () => {
  const { showSnackbar } = useSnackbarContext()
  const mutation = useMutation({
    // Directly pass the object to the mutation function
    mutationFn: draftDocument,
    onSuccess: () => {
      showSnackbar('Document reverted to Draft status', 'success')
      console.log('Successfully reverted document to draft')
    },
    onError: error => {
      console.error('[useDraftDocument] Error setting to draft:', error)
    },
  })

  return mutation
}
